module.exports = __webpack_public_path__ + "img/polygon_large.aab85290.svg";